export default [
  { label: "today", value: "today" },
  { label: "startOfMonth", value: "startOfMonth" },
  { label: "endOfMonth", value: "endOfMonth" },
];
